import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-page-wrapper b-page-wrapper--gray h-flex h-flex-center" }
const _hoisted_2 = { class: "h-flex h-flex-space-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmMyAccountForm = _resolveComponent("ConfirmMyAccountForm")!
  const _component_FwPopup = _resolveComponent("FwPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FwPopup, {
      centered: true,
      isFixed: true,
      "max-width": _ctx.isDesktop() ? "518px" : "calc(100% - 20px)",
      width: "90%",
      popupClass: "b-popup-style--no-shadow",
      allowBackgroundScrolling: true,
      disableClosingOnClickOutside: true,
      popupBackground: "#FAFAFC",
      popupRadius: "20px"
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ConfirmMyAccountForm, {
            class: "b-login-base-popup",
            globalServerError: _ctx.globalServerError,
            onSubmitForm: _ctx.confirmMyAccount
          }, null, 8, ["globalServerError", "onSubmitForm"])
        ])
      ]),
      _: 1
    }, 8, ["max-width"])
  ]))
}